export default __webpack_public_path__ + "static/img/collections-men-knitwear-bg.f26f6a2.jpg";